<template lang="pug">
  DataImportBase(
    :title="'標籤藥物儲存'"
    :uploadUrl="'/upload-tag-drug-storage-table/'"
    :downloadUrl="'/export-tag-drug-storage-table/'"
  )
</template>

<script>
import DataImportBase from './DataImportBase';

export default {
  name: 'TagDrugStorageImport',
  components: {
    DataImportBase,
  },
};
</script>



// WEBPACK FOOTER //
// TagDrugStorageImport.vue?641b2fb0